import type { App } from 'vue';
import PermR from './perm-r.vue';
import PermU from './perm-u.vue';

function setupPermissionComponent(app: App) {
  app.component('PermU', PermU);
  app.component('PermR', PermR);
}

export { PermR, PermU, setupPermissionComponent };
